import { Box, Typography } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import { useLocation, useNavigate } from 'react-router-dom'
import { CompanyStatusCopyWriting } from '../config/copywriting'
import defaultAvatar from 'assets/images/default_avatar.png'
import { removeAllCookies } from 'services/helper/cookiesHelper'
import AdxButton from 'components/custom/AdxButton'

const TextContainer = ({ label, info, status }) => (
  <Box display="flex" width={1} gap={2}>
    <Typography color="light-gray-text.main" width={status === 'ER' ? 1 / 4 : 1 / 7}>
      {label}
    </Typography>
    <Typography width={status === 'ER' ? 3 / 4 : 6 / 7}>{info}</Typography>
  </Box>
)

const SignUpEmail = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  // change this when get API
  // status information
  //  ER = organization existed
  //  CM = jobseeker existed
  const { data } = state
  const {
    address = '',
    address_second = '',
    postcode = '',
    state: region = '',
    country = '',
    mobile_number = '',
    phone_number = '',
    registration_no = '',
  } = data?.company_information || {}
  const copyWriting = CompanyStatusCopyWriting[data.status_code]
  const dataAPI =
    data.status_code === 'ER'
      ? [
          data.name,
          registration_no,
          `${address}, ${address_second}, ${postcode}, ${region}, ${country} `,
        ]
      : [data?.name, data?.email]
  const dataForm = {
    organization_name: data?.status_code === 'ER' ? data?.name : '',
    company_type: '',
    registration_no: registration_no || '',
    mobile_number: mobile_number || phone_number,
    address: address || address_second ? `${address}, ${address_second}` : '',
    postcode,
    state: region,
    country,
  }

  const handleContinue = () => {
    navigate('/signup/form', {
      state: {
        locationBefore: pathname,
        dataForm,
      },
    })
  }

  const handleClose = () => {
    removeAllCookies()
    navigate('/signup')
  }

  return (
    <AdxFormModal
      open={true}
      handleClose={handleClose}
      sx={{
        '&.MuiModal-root': { overflowY: 'auto' },
      }}
      sxModal={{
        minHeight: { xs: '100vh', lg: 600 },
        height: 1,
        maxHeight: '600px',
        width: { xs: 1, lg: 570 },
        overflow: 'hidden',
      }}
      customHeader={null}
    >
      <Box
        width={1}
        height={1}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        {/* Company existed */}
        <Box>
          <Box>
            <Typography variant="h2" mb={1} align="center" fontWeight="medium">
              {copyWriting.header}
            </Typography>
            <Typography variant="body1" textAlign="center" color="light-gray-text.main">
              {copyWriting.subheader}
            </Typography>
          </Box>
          <Box
            bgcolor="default-background.main"
            p={3}
            mt={3}
            borderRadius="10px"
            display="flex"
            flexDirection="column"
            gap={2}
            alignItems="center"
            width={1}
          >
            <Box
              width="110px"
              height="110px"
              borderRadius={100}
              component="img"
              src={data?.image_url || defaultAvatar}
              bgcolor="light-gray-text.main"
            />
            {copyWriting.infoLabel.map((item, index) => (
              <TextContainer
                key={index}
                label={item}
                info={dataAPI[index]}
                status={data.status_code}
              />
            ))}
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" gap={1}>
          <AdxButton onClick={handleContinue}>Continue</AdxButton>
          <AdxButton variant={'outlined'} onClick={handleClose}>
            Use another email
          </AdxButton>
        </Box>
      </Box>
    </AdxFormModal>
  )
}

export default SignUpEmail
